import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  Card, CardContent, Typography, Chip, Box, Stack, Divider,
} from '@mui/material';

const STATUS = {
  0: { label: 'Başlamadı',     color: 'default' },
  1: { label: 'Devam Ediyor', color: 'warning' },
  2: { label: 'Tamamlandı',    color: 'success' },
};

function TaskList() {
  const info = (() => {
    try { return JSON.parse(localStorage.getItem('companyInfo') || 'null'); }
    catch { return null; }
  })();

  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    if (!info?.ID) return;
    axios
      .get('https://portal.peaksoftcon.com:8081/api/tasks', { params: { companyID: info.ID } })
      .then((response) => setTasks(response.data || []))
      .catch((error) => console.error('Error fetching tasks:', error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>Yapılan İşler</Typography>

        {/* Desktop table */}
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{ display: { xs: 'none', md: 'block' } }}
        >
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Görev Adı</TableCell>
                <TableCell>Açıklama</TableCell>
                <TableCell>Durum</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tasks.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ color: 'text.secondary', py: 3 }}>
                    Görev yok.
                  </TableCell>
                </TableRow>
              )}
              {tasks.map((task) => {
                const st = STATUS[task.Task_Status] || STATUS[0];
                return (
                  <TableRow key={task.ID} hover>
                    <TableCell>{task.ID}</TableCell>
                    <TableCell sx={{ fontWeight: 500 }}>{task.Task_Name}</TableCell>
                    <TableCell>{task.Task_Description}</TableCell>
                    <TableCell><Chip size="small" label={st.label} color={st.color} /></TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Mobile card list */}
        <Stack spacing={1.5} sx={{ display: { xs: 'flex', md: 'none' } }}>
          {tasks.length === 0 && (
            <Typography color="text.secondary" align="center" sx={{ py: 3 }}>
              Görev yok.
            </Typography>
          )}
          {tasks.map((task) => {
            const st = STATUS[task.Task_Status] || STATUS[0];
            return (
              <Box key={task.ID} sx={{ p: 1.5, border: 1, borderColor: 'divider', borderRadius: 2 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                  <Box sx={{ minWidth: 0 }}>
                    <Typography variant="body2" color="text.secondary">#{task.ID}</Typography>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{task.Task_Name}</Typography>
                  </Box>
                  <Chip size="small" label={st.label} color={st.color} />
                </Stack>
                {task.Task_Description && (
                  <>
                    <Divider sx={{ my: 1 }} />
                    <Typography variant="body2">{task.Task_Description}</Typography>
                  </>
                )}
              </Box>
            );
          })}
        </Stack>
      </CardContent>
    </Card>
  );
}

export default TaskList;
